import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RopeShovelService } from '../../rope-shovel.service';
import { ComponentRecord, MeasurementPointRecord, ReportConfigVM, Tool } from '../../models/rope-shovel.model';
import { DomSanitizer } from '@angular/platform-browser';
import { MeasurementPointsComponent } from '../measurement-points/measurement-points.component';
import { NotificationsService } from 'angular2-notifications';
import { trigger, transition, style, animate } from '@angular/animations';
import { ViewPhotoComponent } from '../view-photo/view-photo.component';
import { UserService } from '../../../../../app/shared/services/user.service';
import { delay } from 'rxjs/operators';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'component-measurement-table',
  templateUrl: './component-measurement-table.component.html',
  styleUrls: ['./component-measurement-table.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class ComponentMeasurementTableComponent implements OnInit {
  @Input() side: string;
  @Input() compartTypeId: number;
  @Input() inspectionId: number;
  @Input() compartTypeTitle: string;
  @Input() waitForOtherSide: boolean;
  @Input() equipmentId: number;

  @Output() measurementPointUpdated   =  new EventEmitter();
  loadingTable: boolean = true;
  components: ComponentRecord[] = [];
  uom: string = 'mm';
  isAdmin:boolean=false;
  // Calculated fields for the idler component
  showCalculatedFields: boolean = false;
  calcA: number = 0;
  calcB: number = 0;
  calcC: number = 0;
  calcD: number = 0;

  constructor(private _service: RopeShovelService, private _sanitizer: DomSanitizer, public dialog: MatDialog,
    private _user:UserService,
    private _reportConfigService: RopeShovelService,
    private _notify: NotificationsService) { }

  ngOnInit() {
      // TT-1083
      this._service.GetRSReportClient().subscribe(r => {
          if ((r != null) && (r == 'L&H Industrial')) {
              if (this.compartTypeTitle == 'Idler')
                  this.showCalculatedFields = true;
          }
      });
    
    this._service.getUserUom().subscribe(uom => {
      this.uom = uom;
      this.loadTable();
    });
    this.LoadJobRoles();
  }

  LoadJobRoles() {
    this._user.getUserJobRoles().subscribe(roles => {
      roles.forEach(r => {
        switch (r.Name) {
          case 'Inspectors':
            //this.isJobRoleDefault = false;
            //this.isInspector = true;
            break;
          case 'Interpreters':
            //this.isJobRoleDefault = false;
            break;
          case 'Super User':
            //this.isJobRoleDefault = false;
            break;
          case 'Administrator':
            //this.isJobRoleDefault = false;
            this.isAdmin = true;
            break;
          case 'Supervisor':
           // this.isJobRoleDefault = false;
            //this.isSupervisour = true;
            break;
        }
      });

    })
  }

  loadTable() {
    // if(this.waitForOtherSide)
    //  delay(4000);
    this._service.getInspectionComponentMeasurementsForCompartTypeAsync(this.inspectionId, this.compartTypeId, this.side, this.uom).subscribe(r => {
      this.components = r;
      console.log(this.components);

      this.components?.map(x=>{
        let total =0;

        
        x.MeasurementPoints.map(y=>{
          if(y.ContributionWornPercentage!=null){
              total = total + y.ContributionWornPercentage;
          }
        })
        x.SUMWorn=total;
      })

      this.loadingTable = false;
      if (this.showCalculatedFields) {
        r[0].MeasurementPoints.forEach(point => {
          if (point.Name.includes('(A)')) {
            this.calcA = point.Readings[0].Measurement
          }
          else if (point.Name.includes('(B)')) {
            this.calcB = point.Readings[0].Measurement
          }
          else if (point.Name.includes('(C)')) {
            this.calcC = point.Readings[0].Measurement
          }
          else if (point.Name.includes('(D)')) {
            this.calcD = point.Readings[0].Measurement
          }
        });
      }
    });
  }

  updateMeasurementPointComment(comment: string, inspectionDetailId: number, compartMeasurementPointId: number, compartTypeId:number,ReportId:number,MiningShovelReportId:number,Id:number) {
    this._service.updateMeasurementPointComment(inspectionDetailId, compartMeasurementPointId, comment ).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
        let params = new ReportConfigVM();
        params.Id = ReportId ;
        params.CompartTypeId = compartTypeId;
        params.MiningShovelReportId = MiningShovelReportId;
        params.OptionType = 'IncludeComments';
        if (comment != "")
          params.OptionTypeChecked = true;
        else
          params.OptionTypeChecked = false;
        params.InspectionId = this.inspectionId;
        params.InspectionDetailId = inspectionDetailId;
        console.log("params:", params);
        //params.SortOrder = SortOrder;
        this._reportConfigService.SetRSReportMeasurementPointConfig(params).subscribe(res => {
          if (res) {
              this.components.forEach(component => {
                component.MeasurementPoints.forEach(measurementpoint => {
                  if(component.Id==Id && measurementpoint.ReportConfigData.CompartMeasurementPointId==compartMeasurementPointId){
                    measurementpoint.ReportConfigData.IncludeComments = params.OptionTypeChecked;
                  }
                });
              });

            // this.loadingTable=true;
            // this.loadTable();
           /// this.getReportConfigData();
          }
        });
      } else {
        this._notify.alert('Couldn\'t Save', r.m_Item2);
        console.log(r.m_Item2);
      }
    }, err => {
      console.log(err);
      this._notify.alert('Error', 'Unable to update the measurement comment. Please contact support for help. ');
    });
  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  openReadings(readings: MeasurementPointRecord[], inspectionDetailId: number, compartMeasurePointId: number,compartTypeId:number,ReportId:number,MiningShovelReportId:number) {
    let dialogRef = this.dialog.open(MeasurementPointsComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        readings: readings,
        inspectionDetailId: inspectionDetailId,
        compartMeasurePointId: compartMeasurePointId,
        compartType:compartTypeId,
        reportId:ReportId,
        miningShovelReportId:MiningShovelReportId
      }
    });

    dialogRef.afterClosed().subscribe(newData => {
      if (newData == null)
        return;
      this.measurementPointUpdated.emit();
      this.loadTable();
    });
  }

  shouldShowEval(measurementPoint: MeasurementPointRecord): boolean {
    if (measurementPoint.Readings.length == 0 || measurementPoint.Readings == null)
      return false;
    if (measurementPoint.Readings[0].ToolId == Tool.Calipers
      || measurementPoint.Readings[0].ToolId == Tool.DepthGuage
      || measurementPoint.Readings[0].ToolId == Tool.Ruler
      || measurementPoint.Readings[0].ToolId == Tool.UT)
      return true;
    return false;
  }


  viewPhoto(img:string) {
    let viewPhotoModalRef = this.dialog.open(ViewPhotoComponent, {
      data: { photoType: 'measurementpoint_Img', photoId:null, img: img }
    });
    viewPhotoModalRef.afterClosed().subscribe(r => {
        
    });
  }

  toggleIncludes(CompartMeasurementPointId: number, InspectionDetailId: number, MiningShovelReportId: number, MiningShovelReportConfigId: number, Id: number, OptionType: string, event: MatCheckboxChange) {
    let params = new ReportConfigVM();
    params.Id = Id;
    //params.CompartTypeId = CompartTypeId;
    params.MiningShovelReportId = MiningShovelReportId;
    params.MiningShovelReportConfigId = MiningShovelReportConfigId;
    params.OptionType = OptionType;
    params.OptionTypeChecked = event.checked;
    params.InspectionId = this.inspectionId;
    params.InspectionDetailId = InspectionDetailId;
    params.CompartMeasurementPointId = CompartMeasurementPointId;
    params.Side = this.side == "Left" ? 1 : this.side == "Right" ? 2 : 0;
    this._reportConfigService.SetRSReportMeasurementPointConfig(params).subscribe(r => {
      if (r) {
        this._notify.success('Saved', "Data Update Sucessfully.");
      } else {
        this._notify.alert('Couldn\'t Update', "Data not updated. Please contact support for help.");
        //console.log(r.m_Item2);
      }
    }, err => {
      //console.log(err);
      this._notify.alert('Error', 'Unable to update the measurement comment. Please contact support for help. ');
    });
  }

}
